import styled from 'styled-components';
import RunExam from '@/pages/olimpic/RunExam';
import { colors } from 'sama_global/theme';

const StyledRunExam = styled(RunExam)`

table * {
        font-family: "Pama", serif !important;            
        // .MuiTableCell-root {
        //     font-family: Pama, serif !important;
        // }
        
        // .olimpic-answer-cell > div {
        //     font-family: Pama, serif !important;            
        // }
    }

//   & div[type='uamap'] > div {
//     background-color: transparent;

    //   .MuiStepper-root {
    //     background: transparent;
    //   }
    
    .MuiStep-root svg.MuiSvgIcon-root.MuiStepIcon-root.MuiStepIcon-active {
        fill: ${colors.purple};
    }
    button.MuiButtonBase-root.MuiButton-contained.MuiButton-containedPrimary {
        background-color: ${colors.purple};
        border-radius: 8px;
        
        &:hover {
            background-color: ${colors.purple};
            opacity: 0.9;
        }
    }

    .MuiInputBase-root input.MuiInputBase-input {
        color: ${colors.dark};
        font-family: Pama, sans-serif !important;
    }

    // th.MuiTableCell-root {
    //     background-color: ${colors.purple};
    //     color: white;
    // }
    
    .olimpic-answer-cell, .olimpic-number-cell, .olimpic-result-head {
        background-color: ${colors.purple};
        color: ${colors.white};
        .MuiInput-input {
            color: ${colors.dark};
        }
    }

    .olimpic-result-table {
        border: 2px solid ${colors.purple};
        border-radius: 8px;
        border-collapse: unset;
    }
    
    // tr:last-child {
    //     .MuiTableCell-root {
    //         background-color: ${colors.purple};
    //         color: white;
            
    //         .MuiInput-input {
    //             color: black;
    //         }
    //     }
    // }

    .olimpic_timer {
        transform: translateX(-50%);
        // left: 50%;
        border: 2px solid  ${colors.purple};
        font-size: 30px;
        top: 68px;
        // background: transparent;
        // color: ${colors.purple};

        img {
            height: 26px;
            margin-left: 3px;
            // filter: hue-rotate(182deg);
        }
    }

    .olimpic-result-success-block {
        display: none;
    }

    input.MuiInputBase-root {
        color: ${colors.dark};
    }
  }

  @media screen {
  &.pama-print-preview {
    .MuiTableCell-root {
      font-size: 22px !important;
      line-height: 1 !important;
      padding: 5px 1px !important;
    }
    .MuiInput-input {
      font-size: 16px !important;
      height: 18px !important;
      min-width: 24px !important;
    }
    /* Уменьшаем padding ТОЛЬКО для tie-break multiplication/division */
     .pama-tiebreak-math {
      padding-left: 40px !important;
    }
    .pama-tiebreak-math .MuiTableCell-root {
      padding: 4px 1px !important;
    }

  }
}
`;

export default StyledRunExam;
